import styled from 'styled-components';
import { fromMd, timingSlower } from '../../constants';
export const Body = styled.div `
  height: 100%;
  position: relative;
  ${fromMd} {
    padding-bottom: 100%;
  }
`;
export const Image = styled.img `
  position: absolute;
  opacity: ${o => !o.isFocalImage && '0'};
  transition: ${o => !o.isFocalImage && `opacity ${timingSlower} ease`};
  z-index: ${props => (props.isFocalImage ? 1 : 10)};
`;
//# sourceMappingURL=styles.js.map